<template>
  <div>
    <vs-tabs class="invoice-list">
      <vs-tab label="Clinic Details">
        <clinicDetails :canEdit="false" />
      </vs-tab>
      <vs-tab label="Users & Accounts">
        <div>
          <OrganizationAccountsAndUsers :canAssignClinic="false" />
        </div>
      </vs-tab>
      <vs-tab label="Treatments">
        <treatmentList />
      </vs-tab>
      <vs-tab label="Invoices">
        <invoice-list :inTabEdit="true" :clinicInvoices="true" />
      </vs-tab>
      <vs-tab label="Orders">
        <clinic-orderList viewDetailRoute="OrderDetail" />
      </vs-tab>
      <vs-tab label="Settings">
        <clinicSettingsEditDetail />
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import clinicDetails from '../../components/org-owner/clinics/clinicDetails.vue';
import treatmentList from '../../components/org-owner/clinics/treatments.vue';
import invoice from '../../organization/invoices/List.vue';
import ClinicOrderList from '../../components/order-center/order/ClinicOrderList.vue';
import clinicSettingsEditDetail from '../../components/clinics/ViewEditClinicSettings.vue';
import OrganizationAccountsAndUsers from '../../organization/users/index.vue';


export default {
  components: {
    clinicDetails,
    treatmentList,
    'invoice-list': invoice,
    ClinicOrderList,
    clinicSettingsEditDetail,
    OrganizationAccountsAndUsers,
  },
  data: () => ({
    clinicId: '',
  }),
  created() {
    this.clinicId = this.$route.params.clinicId;
  },
};
</script>

<style>
.invoice-list .con-ul-tabs {
  height: 40px;
  overflow-x: auto;
  overflow-y: hidden;
}

.invoice-list .con-ul-tabs::-webkit-scrollbar {
  display: none;
}
</style>
